import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapToConvoAIProductName } from './prompt-requests/utils/get-convoai-supported-product-name';

// Note -- the expectation is this type and the related EditorPluginAIPromptResponseMarkdown
// will be collapsed when we migrate to a single endpoint for all use cases.

/**
 * Only send the X-Product header if the request is to the assistance-service
 * Exported for testing purposes
 */
export var getXProductHeader = function getXProductHeader(product) {
  return {
    'X-Product': mapToConvoAIProductName(product)
  };
};

/**
 * Intended for use with streaming endpoints
 * https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs
 *
 * This sets up the initial connection to the streaming endpoint, handles
 * socket/http connection issues and yields information to
 * streamResponseParser() as events stream in.
 */
export function startStreamingResponse(_x) {
  return _startStreamingResponse.apply(this, arguments);
}
function _startStreamingResponse() {
  _startStreamingResponse = _wrapAsyncGenerator(function (_ref) {
    var endpoint = _ref.endpoint,
      payload = _ref.payload,
      abortController = _ref.abortController,
      getFetchCustomHeaders = _ref.getFetchCustomHeaders,
      product = _ref.product,
      _ref$experienceId = _ref.experienceId,
      experienceId = _ref$experienceId === void 0 ? 'editor' : _ref$experienceId,
      channelId = _ref.channelId;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var actualEndpoint, fetchInit, fetchCustomHeaders, response, knownErrors, _yield$_awaitAsyncGen, error, retryAfter, reader, decoder, buffer, done, _yield$_awaitAsyncGen2, value, doneReading, chunkValue, lines, line, parsedData, _parsedData$error, _parsedData$error2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            actualEndpoint = endpoint; // Using a stateful endpoint
            if (channelId) {
              actualEndpoint = "".concat(endpoint, "/").concat(channelId, "/message/stream");
            }
            fetchInit = {
              method: 'POST',
              headers: _objectSpread({
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId
              }, getXProductHeader(product)),
              // When we move to a single api endpoint we will be able to collapse
              // the current logic spread across;
              // - start-streaming-response
              // - generate, transform, summarise
              // - mapResponseForSingleKeyToMarkdown
              // - and various config items
              // In the meantime -- have opted into this stringify -> parse -> stringify
              // to keep the shapes of startStreamingResponse and startSingleResponse aligned.
              body: payload,
              credentials: 'include',
              signal: abortController.signal,
              mode: 'cors'
            };
            fetchCustomHeaders = (getFetchCustomHeaders === null || getFetchCustomHeaders === void 0 ? void 0 : getFetchCustomHeaders(endpoint, fetchInit)) || {};
            _context.next = 7;
            return _awaitAsyncGenerator(fetch(actualEndpoint, _objectSpread(_objectSpread({}, fetchInit), {}, {
              headers: _objectSpread(_objectSpread({}, fetchInit.headers), fetchCustomHeaders)
            })));
          case 7:
            response = _context.sent;
            if (response.ok) {
              _context.next = 44;
              break;
            }
            if (!(response.status === 400)) {
              _context.next = 31;
              break;
            }
            _context.prev = 10;
            // See
            // - https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-codes
            // for details
            // Errors with special handling
            knownErrors = [
            // We have soft alignment with the BE that for inputs that are not suitable
            // for prompts -- we want to rely on openai providing a suitable message for
            // the user. And not have manually maintained guards/user feedback messages.
            // https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3573548013/Introducing+AI+Dev+Documentation+TODO+AIFOLLOWUP+audit
            'INPUT_TOO_SHORT_TO_SUMMARIZE', 'INPUT_TOO_SHORT_TO_PROCESS', 'INPUT_EXCEEDS_TOKEN_LIMIT'];
            _context.next = 14;
            return _awaitAsyncGenerator(response.json());
          case 14:
            _yield$_awaitAsyncGen = _context.sent;
            error = _yield$_awaitAsyncGen.error;
            if (!error) {
              _context.next = 24;
              break;
            }
            if (!(_typeof(error) === 'object' && 'key' in error && knownErrors.includes(error.key))) {
              _context.next = 21;
              break;
            }
            _context.next = 20;
            return {
              state: 'failed',
              reason: 'backend-input-guard',
              guard: error.key,
              statusCode: response.status
            };
          case 20:
            return _context.abrupt("return", _context.sent);
          case 21:
            _context.next = 23;
            return {
              state: 'failed',
              reason: 'backend',
              error: 'Unhandled error response received',
              statusCode: response.status
            };
          case 23:
            return _context.abrupt("return", _context.sent);
          case 24:
            _context.next = 31;
            break;
          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](10);
            _context.next = 30;
            return {
              state: 'failed',
              reason: 'backend',
              error: _context.t0,
              statusCode: response.status
            };
          case 30:
            return _context.abrupt("return", _context.sent);
          case 31:
            if (!(response.status === 429)) {
              _context.next = 37;
              break;
            }
            // The BE are unable to add the header due to constraints with the service proxy
            // There is a ticket to add this via feature request
            // https://hello.jira.atlassian.cloud/browse/SPSVC-28
            // For now we are just hard coding the value
            retryAfter = response.headers.get('Retry-After');
            if (!retryAfter) {
              retryAfter = '60';
            }
            _context.next = 36;
            return {
              state: 'failed',
              reason: 'rate-limited',
              retryAfter: Number(retryAfter),
              statusCode: response.status
            };
          case 36:
            return _context.abrupt("return", _context.sent);
          case 37:
            if (!(response.status === 451)) {
              _context.next = 41;
              break;
            }
            _context.next = 40;
            return {
              state: 'aup-violation',
              statusCode: 451
            };
          case 40:
            return _context.abrupt("return", _context.sent);
          case 41:
            _context.next = 43;
            return {
              state: 'failed',
              reason: 'backend',
              error: "unexpected response status: ".concat(response.status),
              statusCode: response.status
            };
          case 43:
            return _context.abrupt("return", _context.sent);
          case 44:
            if (response.body) {
              _context.next = 48;
              break;
            }
            _context.next = 47;
            return {
              state: 'failed',
              reason: 'network',
              error: 'response.body missing',
              statusCode: response.status
            };
          case 47:
            return _context.abrupt("return");
          case 48:
            _context.prev = 48;
            reader = response.body.getReader();
            decoder = new TextDecoder('utf-8');
            buffer = '';
            done = false;
          case 53:
            if (done) {
              _context.next = 82;
              break;
            }
            _context.next = 56;
            return _awaitAsyncGenerator(reader.read());
          case 56:
            _yield$_awaitAsyncGen2 = _context.sent;
            value = _yield$_awaitAsyncGen2.value;
            doneReading = _yield$_awaitAsyncGen2.done;
            done = doneReading;
            chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;
            // Split the buffer by line breaks
            lines = buffer.split('\n'); // Process all complete lines, except for the last one (which might be incomplete)
          case 63:
            if (!(lines.length > 1)) {
              _context.next = 79;
              break;
            }
            line = lines.shift();
            parsedData = JSON.parse(line);
            if (!(parsedData.generatedContent === null)) {
              _context.next = 75;
              break;
            }
            if (!(((_parsedData$error = parsedData.error) === null || _parsedData$error === void 0 ? void 0 : _parsedData$error.statusCode) === 429)) {
              _context.next = 71;
              break;
            }
            _context.next = 70;
            return {
              state: 'failed',
              reason: 'rate-limited',
              retryAfter: 60,
              statusCode: 429
            };
          case 70:
            return _context.abrupt("return");
          case 71:
            if (!(((_parsedData$error2 = parsedData.error) === null || _parsedData$error2 === void 0 ? void 0 : _parsedData$error2.key) === 'RESPONSE_TOO_SIMILAR')) {
              _context.next = 75;
              break;
            }
            _context.next = 74;
            return {
              state: 'failed',
              reason: 'response-too-similar',
              statusCode: 208,
              data: parsedData
            };
          case 74:
            return _context.abrupt("return");
          case 75:
            _context.next = 77;
            return {
              state: 'loading',
              data: parsedData
            };
          case 77:
            _context.next = 63;
            break;
          case 79:
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
            _context.next = 53;
            break;
          case 82:
            _context.next = 84;
            return {
              state: 'loaded-stream'
            };
          case 84:
            return _context.abrupt("return");
          case 87:
            _context.prev = 87;
            _context.t1 = _context["catch"](48);
            _context.next = 91;
            return {
              state: 'failed',
              reason: 'parsing',
              error: _context.t1,
              statusCode: response.status
            };
          case 91:
            return _context.abrupt("return");
          case 92:
            _context.next = 110;
            break;
          case 94:
            _context.prev = 94;
            _context.t2 = _context["catch"](0);
            if (!(_context.t2.name === 'AbortError')) {
              _context.next = 101;
              break;
            }
            _context.next = 99;
            return {
              state: 'failed',
              reason: 'aborted',
              error: _context.t2,
              statusCode: _context.t2.status
            };
          case 99:
            _context.next = 109;
            break;
          case 101:
            if (!(_context.t2.cause === 'ConvoAIChannelCreationError')) {
              _context.next = 106;
              break;
            }
            _context.next = 104;
            return {
              state: 'failed',
              reason: 'backend',
              error: _context.t2,
              statusCode: _context.t2.status
            };
          case 104:
            _context.next = 109;
            break;
          case 106:
            // This can be due to code crashes too, but falls back to network errors
            // eslint-disable-next-line no-console
            console.error('Editor AI: startStreamingResponse()', _context.t2);
            _context.next = 109;
            return {
              state: 'failed',
              reason: 'network',
              error: _context.t2,
              statusCode: _context.t2.status
            };
          case 109:
            return _context.abrupt("return");
          case 110:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 94], [10, 26], [48, 87]]);
    })();
  });
  return _startStreamingResponse.apply(this, arguments);
}